// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"09e77db4","195":"89648609","261":"05c61814","453":"3f038b64","473":"4a9a2e6c","499":"182cfdf9","607":"df210597","694":"6f1b1f15","705":"a746bddf","803":"5639f4eb"}[chunkId] + ".chunk.js";
};